import React from 'react';
import {
  Modal, Button, Row, Col,
} from 'react-bootstrap';

function MyModalComponent(props) {
  return (
    <>
      <div>
        <Modal show={props.show} onHide={() => props.onHide({ msg: 'Cross Icon Clicked!' })}>
          <Modal.Header closeButton>
            <Modal.Title>
              {props.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {props.body}

            <Row>
              <Col lg="6">
                <p>  Claim ID: {(props.data.CLAIM_ID) ? (props.data.CLAIM_ID) : ''} </p>
                <p> Description: {(props.data.DESCRIPTION) ? (props.data.DESCRIPTION) : ''} </p>
                {(props.data.CLAIM_STATUS) === 'Paid'
                && <>
                  <p>Invoice No: {(props.data.INVOICE_NO) ? (props.data.INVOICE_NO) : ''}</p>
                  <p>Cheque No: {(props.data.CHECK_NUMBER) ? (props.data.CHECK_NUMBER) : ''}</p>
                </>
                }

              </Col>
              <Col lg="6">
                <p> Office: {(props.data.OFFICE_NAME) ? (props.data.OFFICE_NAME) : ''}</p>
                <p>Claim Status: {(props.data.CLAIM_STATUS) ? (props.data.CLAIM_STATUS) : ''}</p>
                {(props.data.CLAIM_STATUS) === 'Paid'
                && <>
                  <p>Cheque Date: {(props.data.CHECK_DATE) ? (props.data.CHECK_DATE) : ''}</p>
                  <p>Cheque AMOUNT: {(props.data.CHECK_AMOUNT) ? (props.data.CHECK_AMOUNT) : ''}</p>
                </>
                }
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => props.onClick({ msg: 'Modal Closed!' })} >Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
export default MyModalComponent;
